/**
 * Стол из QR-кода. В зале заказ без стола не оформляется, поэтому источник
 * только один — ссылка, по которой гость открыл меню:
 *
 * - `https://host/?table=12` — QR ведёт в браузер;
 * - `t.me/<bot>?startapp=table_12` — Telegram Mini App, параметр в `start_param`;
 * - `resto://table/12` — приложение (параметр подставляет нативный хост).
 *
 * Ручного ввода номера стола нет: опечатка отправляет заказ на чужой стол.
 */
const TABLE_PATTERN = /^[A-Za-z0-9_-]{1,32}$/;

export function tableFromStartParam(value: string | null | undefined): string | null {
  if (!value) return null;
  const match = /^table_([A-Za-z0-9_-]{1,32})$/.exec(value);
  return match?.[1] ?? null;
}

export function tableFromQuery(value: string | null | undefined): string | null {
  if (!value) return null;
  return TABLE_PATTERN.test(value) ? value : null;
}

type TelegramWindow = {
  Telegram?: { WebApp?: { initDataUnsafe?: { start_param?: string } } };
};

/** Стол из адреса страницы, иначе из параметра запуска Telegram. */
export function currentTable(): string | null {
  const fromQuery = tableFromQuery(new URLSearchParams(window.location.search).get('table'));
  if (fromQuery) return fromQuery;
  const telegram = (window as unknown as TelegramWindow).Telegram;
  return tableFromStartParam(telegram?.WebApp?.initDataUnsafe?.start_param);
}
